import { useThemeStore } from '@/utils/themeStore';
import React from 'react';
import { useTranslation } from 'react-i18next';

// The lab dashboard is a page of the Protomia gateway, framed here so it ships with the backend (which decides
// who sees whom). Same origin, so the page finds the login in localStorage; the light/dark choice is passed on.
const LabPage: React.FC = () => {
    const theme = useThemeStore((state) => state.theme);
    const { t } = useTranslation('common');
    const src = `${import.meta.env.VITE_PROTOMIA_URL ?? ''}/lab?theme=${theme}`;
    return (
        <div className='w-full h-full'>
            <iframe title={t('sidebar.lab')} src={src} className='w-full h-full' style={{ border: 0 }} />
        </div>
    );
};

export default LabPage;
